import { render, staticRenderFns } from "./Show.vue?vue&type=template&id=49ae6f20&scoped=true&"
import script from "./Show.vue?vue&type=script&lang=js&"
export * from "./Show.vue?vue&type=script&lang=js&"
import style0 from "../../components/common/css/Accreditation.css?vue&type=style&index=0&id=49ae6f20&scoped=true&lang=css&"
import style1 from "./Show.vue?vue&type=style&index=1&id=49ae6f20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ae6f20",
  null
  
)

export default component.exports